import { Injectable } from '@angular/core';
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NotificationService } from 'src/app/signalr/notification.service';
import FeaUtils from '../../FeaUtils';
import { FeaBaseProcessService } from './fea-base-process.service';
import { VectorResult } from '../../models/results/vector-result';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeaThicknessUpdateService {

  constructor(
    private readonly feaBaseProcessService : FeaBaseProcessService,
    private readonly http: HttpClient,
    private readonly notificationService: NotificationService,
  ) {
  }

  public async getResult(): Promise<any> {
    const request = await this.feaBaseProcessService.getBaseProcessRequest();

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0'
      }),
      responseType: 'json' as 'json'
    };

    try {
      const resultData = await firstValueFrom(this.http.post(environment.API_FEA + `ThicknessUpdate/GetResult`, request, options));
      const vectorResult = new VectorResult(resultData);

      const csvText = await firstValueFrom(this.http.get(vectorResult.ResultUrl, { responseType: 'text' as 'text' }));
      var valuesPerElement = FeaUtils.ExtractValuesFromCSV(csvText);
      return {
        valuesPerElement: valuesPerElement,
        title: null,
        processResult: vectorResult
      };
    }
    catch (err) {
      console.log(err);
      this.notificationService.addFailedNotification("Failed to get or parse thickness update result");
      return null; // Indicate failure
    }
  }
}
